import { ActionType, createReducer } from 'typesafe-actions';
import { combineReducers } from 'redux';
import { FETCH_REGIONS_AND_STORES } from './actions';
import { RegionsStoresResponse } from './types';

export type RegionsAndStoresActions = ActionType<typeof FETCH_REGIONS_AND_STORES.success>;
export const regionsAndStoresReducer = createReducer<RegionsStoresResponse | null, RegionsAndStoresActions>(
  null,
).handleAction(FETCH_REGIONS_AND_STORES.success, (_, { payload }) => payload);

export type RegionsAndStoresAreLoadingReducerActions =
  | ActionType<typeof FETCH_REGIONS_AND_STORES.request>
  | ActionType<typeof FETCH_REGIONS_AND_STORES.success>
  | ActionType<typeof FETCH_REGIONS_AND_STORES.failure>
  | ActionType<typeof FETCH_REGIONS_AND_STORES.cancel>;
export const regionsAndStoresAreLoadingReducer = createReducer<
  boolean,
  RegionsAndStoresAreLoadingReducerActions
>(false)
  .handleAction(FETCH_REGIONS_AND_STORES.request, () => true)
  .handleAction(
    [FETCH_REGIONS_AND_STORES.success, FETCH_REGIONS_AND_STORES.failure, FETCH_REGIONS_AND_STORES.cancel],
    () => false,
  );

export const businesUnitsReducer = combineReducers({
  regionsAndStores: combineReducers({
    data: regionsAndStoresReducer,
    areLoading: regionsAndStoresAreLoadingReducer,
  }),
});
